import React from 'react'
import PropTypes from 'prop-types'
import { SmartviewBackTrigger, useSmartviewManager } from '@morningtrain/react-smartviews'
import SmartviewHeader from 'widgets/smartviews/partials/SmartviewHeader'
import { BackButton } from 'ui/buttons'
import Widget from 'widgets/Widget'

function Smartview (props) {
  const smartviewManager = useSmartviewManager()

  React.useEffect(() => {
    smartviewManager.resize(props.size)
  }, [props.size])

  return (
    <Widget>
      <div className='smartview-wrapper flex flex-col absolute top-12 bottom-8 left-0 right-0 xl:top-14 xl:bottom-12'>
        <SmartviewBackTrigger>
          <div className='px-8 mb-6'>
            <BackButton>Tilbage</BackButton>
          </div>
        </SmartviewBackTrigger>
        <div className='px-8 flex-col'>
          <SmartviewHeader>
            {props.header}
          </SmartviewHeader>
        </div>
        <div className={'flex-col flex-wrap flex-grow overflow-y-auto overflow-x-hidden ' + (props.tight === false ? 'px-8' : '')}>
          {props.children}
        </div>
        {
          props.footer
            ? <div className={'border-gray-300 flex-col ' + (props.tight === false ? 'px-8 pt-4 xl:pt-8' : '')}>{props.footer}</div>
            : null
        }
      </div>
    </Widget>
  )
}

Smartview.defaultProps = {
  size: 'xs',
  header: null,
  footer: null,
  tight: false
}

Smartview.propTypes = {
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', '2xl', '3xl', '4xl', '5xl', '6xl', 'full']),
  header: PropTypes.node,
  footer: PropTypes.node,
  tight: PropTypes.bool
}

export default Smartview
